/**
 * RESPONSIBILITY: draw a band that is a short list of labelled facts — service times, an address.
 *
 * A definition list, because that is what it is: a label and what it is the label of. The
 * same markup and classes an event's facts use, so a fact reads the same on both.
 */
import { idOf } from '@framework/core';
import { BandFrame } from './BandFrame';
import { BandButtons } from './BandButtons';
import type { BandDef, BandProps } from './kind';

const shown = (b: BandProps['b']) => (b.facts ?? []).filter((f) => f.label || f.value);

function Draw({ b, tinted }: BandProps) {
  return (
    <BandFrame tinted={tinted} heading={b.heading}>
      <dl className="ev-facts">
        {shown(b).map((f, i) => (
          <div key={idOf(f) || i}>
            <dt>{f.label}</dt>
            <dd>{f.value}</dd>
          </div>
        ))}
      </dl>
      <BandButtons b={b} />
    </BandFrame>
  );
}

export const facts: BandDef = { has: (b) => shown(b).length > 0, Draw };
